import logger from 'utils/logger.util';

import { GET_VERSION_SUCCESS } from 'salon/actions';
import {
  CREATE_PIN_FAILURE,
  CREATE_PIN_REQUEST,
  CREATE_PIN_SUCCESS,
  EMAIL_PIN_FAILURE,
  EMAIL_PIN_REQUEST,
  EMAIL_PIN_SUCCESS,
  GET_PIN_FAILURE,
  GET_PIN_REQUEST,
  GET_PIN_SUCCESS,
  RESET_PIN_FAILURE,
  RESET_PIN_REQUEST,
  RESET_PIN_SUCCESS,
  SET_REDIRECT_URI,
  SET_USER_PERMISSIONS,
} from 'salon/constants';

const L = logger('userPermission');

// FIXME: expects pinCodes named field, but is called with state one instead
const mergePinCodes = (options) => {
  const { stylist: stylistId, salon: salonId, pin, status } = options?.response ?? {};

  if (!stylistId) L.warn('mergePinCodes()', 'Invalid stylistId:', stylistId);

  return {
    ...(options?.pinCodes ?? void 1),
    [stylistId]: { pin, status, salonId, stylistId },
  };
};

const initState = () => ({
  permission: null,
  latestRelease: '',
  redirectUri: '',
  isFetching: false,
  pinCodes: null,
  status: '',
  emailsWithLogin: [],
});

const userPermissionReducer = (state = initState(), action) => {
  const { type, error, params, response, redirectUri } = action ?? {};
  if (!type) return state;

  if (type === CREATE_PIN_REQUEST) return { ...state, isFetching: true };
  if (type === CREATE_PIN_FAILURE) return { ...state, isFetching: false, error };
  if (type === CREATE_PIN_SUCCESS) return { ...state, isFetching: false, pinCodes: mergePinCodes({ state, response }) };
  if (type === GET_PIN_REQUEST) return { ...state, isFetching: true };
  if (type === GET_PIN_FAILURE) return { ...state, isFetching: false, error };
  if (type === GET_PIN_SUCCESS) return { ...state, isFetching: false, pinCodes: mergePinCodes({ state, response }) };
  if (type === RESET_PIN_REQUEST) return { ...state, isFetching: true };
  if (type === RESET_PIN_FAILURE) return { ...state, isFetching: false, error };
  if (type === RESET_PIN_SUCCESS) return { ...state, isFetching: false, pinCodes: mergePinCodes({ state, response }) };
  if (type === EMAIL_PIN_REQUEST) return { ...state, isFetching: true };
  if (type === EMAIL_PIN_FAILURE) return { ...state, isFetching: false, error };
  if (type === EMAIL_PIN_SUCCESS) return { ...state, isFetching: false };
  if (type === SET_USER_PERMISSIONS) return params?.permission ? { ...state, ...params } : { ...state };
  if (type === SET_REDIRECT_URI) return { ...state, redirectUri };

  if (type === GET_VERSION_SUCCESS) {
    const latestRelease = response?.latest_release;
    L.debug('userPermissionReducer()', GET_VERSION_SUCCESS, 'latestRelease:', latestRelease);
    return { ...state, latestRelease };
  }

  return state;
};

// noinspection JSUnusedGlobalSymbols
export default userPermissionReducer;
